






















































import { Component, Watch, Vue, Prop, Emit } from 'vue-property-decorator'; // デコレータ
// 共通機能
import ApiAccessBase from '../../CommonFeature/components/ApiAccessBase.vue';
import router from '../../router';
// 定数ファイル
import { Constants } from '../../CommonUtils/fixed/Constants';
import { UketsukeConstants } from '../fixed/UketsukeConstants';
import { Message } from '../../CommonUtils/fixed/Message';
import { ScreenMode } from '../../CommonUtils/fixed/ScreenMode';
import { ScreenName } from '../../CommonUtils/fixed/ScreenName';
import { UketsukeScreenName } from '../fixed/UketsukeScreenName';
// 共通モジュール
import { supervisingModule } from '../../store/modules/OperationSupervising';
import { routingControlModule } from '@/store/modules/RoutingControl';
import { applicationFormModule } from '../store/modules/ApplicationForm';
// dto
import { ISearchLog } from '../store/dto/ChangeLog';

// コンポーネント登録
Vue.component('ApiAccessBase', ApiAccessBase);

@Component
export default class ApplicationChangeLog extends ApiAccessBase {
  // ページネーション部品の初期値設定平成
  private page = 1;  // 初めに表示するページの番号（基本的に1で固定）
  private itemPerPage = 10; // 1ページあたりに表示するレコードの数
  private pageCount =  0; // ページカウントの初期化(0固定)
  // 検索結果ヘッダの設定
  private headers = [
    {
      text: '変更項目',
      align: 'center',
      sortable: false,
      value: 'henkouItem',
      width: 150,
    },
    {
      text: '申請先自治体',
      align: 'center',
      sortable: false,
      value: 'kikanName',
      width: 120,
    },
    {
      text: '変更前',
      align: 'center',
      sortable: false,
      value: 'henkoumaeInformation',
    },
    {
      text: '変更後',
      align: 'center',
      sortable: false,
      value: 'henkougoInformation',
    },
    {
      text: '申請受理日',
      align: 'center',
      sortable: true,
      value: 'acceptDate',
      width: 120,
    },
  ];
  private created() {
    this.screenTitle = '変更申請履歴';

    // モジュールに現在の画面を記録
    routingControlModule.registCurrent(this.$route.name);
    // 前画面から渡された情報で変更申請履歴を検索
    const req: ISearchLog = {
      tenantId: '',
      traderId: applicationFormModule.GET_TRADER_ID,
      traderType: applicationFormModule.GET_APP_TYPE,
    };
    this.formData  = req;
    this.createSendForm();
    // APIアクセス
    this.apiAccess(UketsukeConstants.APP_CHANGE_LOG, Constants.API_METHOD_POST, true, true).then(
      (result) => {
        if ((result) === Constants.API_RESULT_SUCCES) {
        }
      },
    );

  }

  /**
   * 前画面に戻る
   */
  private returnPrevious() {
      // 前画面に戻る
      router.push({name: UketsukeScreenName.APP_TRADER_SEARCH});
  }
}
